<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import BenefitsGridSection from "./BenefitsGridSection.svelte";
	import translations from "./FathersClubAdvantagesSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	interface Benefit {
		bgClass: string;
		title: string;
		description: string;
		dark: boolean;
	}

	const benefits: Benefit[] = [
		{
			bgClass: "bg-fcramber",
			title: translate("benefit1Title"),
			description: translate("benefit1Description"),
			dark: false,
		},
		{
			bgClass: "bg-fcrtan",
			title: translate("benefit2Title"),
			description: translate("benefit2Description"),
			dark: false,
		},
		{
			bgClass: "bg-fcrslate",
			title: translate("benefit3Title"),
			description: translate("benefit3Description"),
			dark: false,
		},
		{
			bgClass: "bg-fcrterracotta",
			title: translate("benefit9Title"),
			description: translate("benefit9Description"),
			dark: false,
		},
		{
			bgClass: "bg-fcrbrown",
			title: translate("benefit4Title"),
			description: translate("benefit4Description"),
			dark: true,
		},
		{
			bgClass: "bg-fcrblue",
			title: translate("benefit5Title"),
			description: translate("benefit5Description"),
			dark: false,
		},
		{
			bgClass: "bg-fcrsalmon",
			title: translate("benefit6Title"),
			description: translate("benefit6Description"),
			dark: true,
		},
		{
			bgClass: "bg-fcrlinen",
			title: translate("benefit7Title"),
			description: translate("benefit7Description"),
			dark: true,
		},
		{
			bgClass: "bg-fcrperiwinkle",
			title: translate("benefit8Title"),
			description: translate("benefit8Description"),
			dark: true,
		},
	];
</script>

<BenefitsGridSection
	section={translate("section")}
	sectionClass="bg-fcrbeige"
	captionClass="text-fcrorange"
	title={translate("title")}
	desktopWrapperClass="bg-white"
	cards={benefits.map((benefit) => ({
		title: benefit.title,
		description: benefit.description,
		class: [benefit.bgClass, !benefit.dark && "text-white"],
	}))}
/>
